import VendorScoreDashboardComponent from "../../vendorScoreDashboard";

export const COLUMN_TYPE_TO_COMPONENT_FACTORY = {
  'Registered Vendor Name': VendorScoreDashboardComponent
}